import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { Scrollbars } from "react-custom-scrollbars";
import classNames from "classnames";
import { bindActionCreators } from "redux";

import {
  Attachment,
  AttachmentProgress,
} from "../../../../../common/attachments/";
import { RectangleSpinner } from "../../../../../common/spinners";

import { FOLLOW_UP_ATTACHMENTS } from "../../../../../../utils/data/models";
import * as downloaderActions from "../../../../../../utils/downloader/downloaderActions";
import { connect } from "react-redux";
import { buildQueryString } from "../../../../../../../utils/url";
import AttachmentsDownloader from "../../../../../../utils/downloader/AttachmentsDownloader";
import { onDrop } from "../../../../../common/attachments/S3UploaderHelper";
import { getTenantFromURL } from "../../../../../common/MultiTenancy/MultiTenancyHelper";
import { getSessionCookies } from "../../../../../common/sessions/tokenHelper";
import loginApi from "../../../../../login/loginApi";

const MAX_FILE_NAME_LENGTH = 1024;

const FollowUpAttachments = (props) => {
  const extractQueryParams = (url) => {
    if (!url) {
      return {};
    }

    return (/^[?#]/.test(url) ? url.slice(1) : url)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {});
  };

  const { shortLivedURL } = props;
  const renderDownloader = !!shortLivedURL && shortLivedURL != "";

  let url, queryParams;
  if (renderDownloader) {
    url = shortLivedURL.substr(0, shortLivedURL.indexOf("?"));
    queryParams = extractQueryParams(
      shortLivedURL.substr(shortLivedURL.indexOf("?"))
    );
  }


  let s3path = url + buildQueryString(queryParams, url);
  const fileName = s3path.split('/').pop().split('?')[0];

  let downloadData = !!fileName && !!url && !!queryParams;
  
  let [accessToken, refreshToken] = getSessionCookies();
  accessToken = `JWT ${accessToken}`;

  const tenant = getTenantFromURL();

  const handleError = (err) => {
    // 400 is returned by API when token is not valid
    if (err.startsWith("Could not contact request signing server. Status = 400")) loginApi.login({returnSessionError: true});
  };

  const uploaderProps = {
    style: {},
    server: __API_URL__,
    maxFileSize: 1024 * 1024 * 100,
    isImage: () => false,
    progressComponent: AttachmentProgress,
    fileComponent: () => null,
    signingUrl: FOLLOW_UP_ATTACHMENTS.signingPath,
    signingUrlMethod: "GET",
    signingUrlHeaders: { Authorization: accessToken, "Refresh-Token": refreshToken, Tenant: tenant },
    signingUrlQueryParams: {
      clientMethod: "put_object",
      objectPath: props.followUpGuid,
      bucket_type: "FOLLOW_UPS",
    },
    uploadRequestHeaders: { "Access-Control-Allow-Origin": "*" },
    contentDisposition: "attachment",
    onDrop: onDrop,
    onFinish: props.handleUploadFinish,
    onError: handleError,
  };

  const list = (showNoFilesMessage) => {
    const listClassNames = classNames({
      "attachment-list": true,
      "not-empty":
        !!props.followUpAttachments && props.followUpAttachments.length > 0,
    });
    let content = "";

    if (props.followUpAttachments == null && !!props.followUpId) {
      content = <RectangleSpinner />;
    } else if (
      !!props.followUpAttachments &&
      props.followUpAttachments.length > 0
    ) {
      content = (
        <Scrollbars
          autoHide={true}
          style={{ height: 130 }}
          renderView={({ ...props }) => (
            <div {...props} className="attachment-scrollarea" />
          )}
        >
          {props.followUpAttachments.map((attachment, index) => {
            return (
              <Attachment
                key={index}
                readOnly={props.readOnly}
                handleAttachmentDelete={props.handleAttachmentDelete}
                handleAttachmentDownload={props.handleAttachmentDownload}
                {...{ ...attachment, filePath: props.followUpGuid }}
              />
            );
          })}
        </Scrollbars>
      );
    } else if (showNoFilesMessage) {
      content = (
        <p className="empty-attachment-list">
          <FormattedMessage id="attachments.attachmentListEmpty" />
        </p>
      );
    }
    return <div className={listClassNames}>{content}</div>;
  };

  return (
    <div className="attachments">
      <h5>
        <FormattedMessage id="attachments.attachmentLabel" />
      </h5>
      {!props.readOnly && (
        <p>
          <FormattedMessage id="attachments.attachmentWarning" values={{ length: MAX_FILE_NAME_LENGTH }} />
          <span className="required"> *</span>
        </p>
      )}
      <div className="attachments-zone">
        {!props.readOnly && (
          <div className="uploader">
            <DropzoneS3Uploader
              id="followUpAttachmentUploader"
              name="followUpAttachmentUploader"
              {...uploaderProps}
            >
              <div>
                <p className="description">
                  <span className="icon icon-out" />
                  <FormattedMessage id="attachments.attachmentDescription" />
                </p>
                {list(false)}
              </div>
            </DropzoneS3Uploader>
          </div>
        )}
        {props.readOnly && list(true)}

        {renderDownloader && downloadData &&
          <AttachmentsDownloader
            url = {url}
            queryParams = {queryParams}
            fileName = {fileName}
            onDownloaded = {props.handleAttachmentDownloaded}
          />
        }
      </div>
    </div>
  );
};

FollowUpAttachments.propTypes = {
  followUpGuid: PropTypes.string,
  followUpId: PropTypes.number,
  followUpAttachments: PropTypes.array,
  readOnly: PropTypes.bool,
  shortLivedURL: PropTypes.string,
  handleAttachmentDelete: PropTypes.func,
  handleAttachmentDownload: PropTypes.func,
  handleAttachmentDownloaded: PropTypes.func,
  handleUploadFinish: PropTypes.func,
};


const mapDispatchToProps = (dispatch) => {
  return {
    downloaderActions: bindActionCreators(downloaderActions, dispatch)
  };
};

const mapStateToProps = (state) => {
  const currentDownloads = state.downloader || {};
  return {
    currentDownloads: currentDownloads.files
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(FollowUpAttachments);


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/attachments/FollowUpAttachments.js